<h6 class="loginHeadingText text-start">KEY DATES</h6>
<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <label>Initiated Date</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <span class="font-13" id="initiatedDate">{{keyDatesInfo.initiatedDate | date:'dd-MMM-yyyy'}}</span>
        <!-- <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onLeadTimeChange($event)" [disabled]="disableAfterReview"
            [(ngModel)]="ldDate"> </p-calendar> -->
    </div>
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
    <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 align-self-center"> -->
        <label>START DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 text-end pe-3">
    <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 text-end pe-3"> -->.
       
            <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
                (ngModelChange)="onStartDateChange($event)" id ="startDate"
                [minDate]="minDateForStartDate!" [disabled]="disableAll"
                [(ngModel)]="keyDatesInfo.startDate"> </p-calendar>
    </div>

    
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
    <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5"> -->
        <label>END DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
    <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3"> -->
        <!-- <span class="font-13" id="endDate">{{keyDatesInfo.endDate | date:'dd-MMM-yyyy'}}</span> -->
         <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onEndDateChange($event)" id ="endDate"
            [minDate]="minDateForEndDate!"
            [disabled]="disableAll"
            [(ngModel)]="keyDatesInfo.endDate"> </p-calendar>
    </div>
</div>

<!-- <div class="row mb-12px mt-16">
    <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 align-self-center">
        <label>LEAD TIME</label>
    </div>
    <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 text-end pe-3">
        <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onLeadTimeChange($event)" [disabled]="disableAfterReview"
            [(ngModel)]="ldDate"> </p-calendar>
    </div>
</div> -->

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center pe-0">
    <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5"> -->
        <label>SUBMITTED FOR REVIEW</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
    <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3"> -->
        <span class="font-13" id="submittedDate">{{keyDatesInfo.submittedDate | date:'dd-MMM-yyyy'}}</span>
        <!-- <span class="font-13" id="submittedDate"></span> -->
    </div>
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
    <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5"> -->
        <label>APPROVED ON</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
    <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3"> -->
        <span class="font-13" id="approvedOn">{{keyDatesInfo.approvedOn | date:'dd-MMM-yyyy'}}</span>
    </div>
</div>


<div class="row mb-12px mt-16">
    <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
    <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 align-self-center"> -->
        <label>PWR DATE</label>
    </div>
    <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
    <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 text-end pe-3"> -->
        <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onPWRDateChange($event)" [disabled]="!enablePWR" [ngClass]="{'disabled-calendar':!enablePWR }"
            [minDate]="today!"
            [(ngModel)]="keyDatesInfo.pwrDate"> </p-calendar>
    </div>
</div>

<fieldset [disabled]="!disableExecStart">
    <div class="row mb-12px mt-16">
        <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 "> -->
            <label>EXECUTION START</label>
        </div>
        <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3"> -->
            <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
                (ngModelChange)="onExecutionStartChange($event)"
                [minDate]="minDateForExecStartDate!" 
                [(ngModel)]="keyDatesInfo.executionStart"> 
            </p-calendar>        
            <button class="btn btn-sm executionStart mt-2" [ngClass]="{'disabled-button':!disableExecStart }" (click)="onExecutionStartClick()">Execution Started</button>
        </div>
    </div>
</fieldset>

<fieldset [disabled]="!disableExecEnd">
    <div class="row mb-12px mt-16">
        <div class="col-md-5 col-lg-6 col-xl-6 col-xxl-6 align-self-center">
        <!-- <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5"> -->
            <label>EXECUTION END</label>
        </div>
        <div class="col-md-4 col-lg-6 col-xl-6 col-xxl-6 pe-3">
        <!-- <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3"> -->
            <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
                (ngModelChange)="onExecutionEndChange($event)" 
                [minDate]="execSD!"
                [(ngModel)]="keyDatesInfo.executionEnd"> 
            </p-calendar>        
            <button class="btn btn-sm executionStart mt-2" (click)="onExecutionCompletedClick();" [ngClass]="{'disabled-button':!disableExecEnd }">Execution Completed</button>
        </div>
    </div>
</fieldset>


<div class="row mb-12px mt-16">
    <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 pe-0">
        <label>VERIFICATION START</label>
    </div>
    <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3">
        <span class="font-13">{{keyDatesInfo.verificationStart | date:'dd-MMM-yyyy'}}</span>
    </div>
</div>

<div class="row mb-12px mt-16">
    <div class="col-md-4 col-lg-5 col-xl-5 col-xxl-5 align-self-center">
        <label>VERIFICATION END</label>
    </div>
    <div class="offset-xxl-1 col-md-8 col-lg-7 col-xl-7 col-xxl-6 pe-3">
        <span class="font-13">{{keyDatesInfo.verificationEnd | date:'dd-MMM-yyyy'}}</span>
        <!-- <p-calendar dateFormat="dd-M-yy" [style]="{'width':'100%','margin-top':'3px'}" 
            (ngModelChange)="onExecutionEndChange($event)" 
            [(ngModel)]="keyDatesInfo.verificationEnd"> </p-calendar> -->
    </div>
</div>
